import React from "react";

const GreyLine = (props) => {
  return (
    <>
      
      <div className={props.lineColour ? props.lineColour : 'greyLine'}></div>

    </>
  );
};

export default GreyLine;
